import { MapServiceApi } from "../../../impl/layers/server/ArcGIS_APIResponse";
import { Maybe, None, Some } from "../../misc/option";
import { EPSG } from "../../projection";
import { LayerUIFactory } from "../../ui/layer";
export class ServerLayer {
    constructor(opts) {
        this.projection = EPSG(3857);
        this.loaded = false;
        this.is_base = false;
        this.raw = None.instance();
        this.name = "baseserverlayer";
        this.ui = None.instance();
        this.api = None.instance();
        if (!this.validate(opts)) {
            console.error("ServerLayer initialized with invalid parameters.");
            return;
        }
        this.parse_config(opts).then(() => this.on_create());
    }
    get source() { return this.raw.map((a) => a.getSource()); }
    get visible() { return this.raw.map(a => a.getVisible()).unwrapOr(false); }
    set visible(v) {
        this.raw
            .map(l => l.setVisible(v))
            .map(() => $(`#${this.name.replace(/\s/g, '')}`).prop('checked', v));
    }
    get opacity() { return this.raw.map(a => a.getOpacity()).unwrapOr(0); }
    set opacity(v) {
        this.raw.map(l => l.setOpacity(v));
    }
    changed() {
        this.raw.map(a => a.changed());
    }
    on_create() {
        this.create_ui();
    }
    create_ui() {
        if (this.loaded)
            return;
        this.ui = Maybe(LayerUIFactory.construct_ui_for(this));
        this.loaded = true;
    }
    async make_get_request(url = "", params = { f: 'json' }) {
        let fillUrl = new URL(url.slice(0, 4) === 'http' ? url : 'https:' + url);
        Object.keys(params).forEach(key => fillUrl.searchParams.append(key, params[key]));
        const response = await fetch(fillUrl.toString(), {
            method: "GET",
            mode: 'cors',
            cache: 'default',
            redirect: 'follow'
        });
        return response;
    }
    async get_service_api(urls = [""]) {
        if (this.api.isNone()) {
            const info = await this.make_get_request(urls[0]).then(res => res.json());
            const api = new MapServiceApi(urls, info);
            this.api = new Some(api);
            return api;
        }
        return this.api.unwrap();
    }
}
